import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { FarmNoteType } from '../models/farm-note';

@Injectable({ providedIn: 'root' })
export class FarmNoteTypeService {
  private basePath = environment.PLATFORM_API_URL;

  constructor(private http: HttpClient) { }

  /** Active types only. */
  list(): Observable<FarmNoteType[]> {
    return this.http.get<FarmNoteType[]>(`${this.basePath}/api/farm-note-types`);
  }

  /** Includes deactivated types, for the manager dialog. */
  listAll(): Observable<FarmNoteType[]> {
    return this.http.get<FarmNoteType[]>(`${this.basePath}/api/farm-note-types?includeInactive=true`);
  }

  create(t: FarmNoteType): Observable<FarmNoteType> {
    return this.http.post<FarmNoteType>(`${this.basePath}/api/farm-note-types`, t);
  }

  update(t: FarmNoteType): Observable<FarmNoteType> {
    return this.http.put<FarmNoteType>(`${this.basePath}/api/farm-note-types/${t.id}`, t);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.basePath}/api/farm-note-types/${id}`);
  }
}
